import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
  slots: {
    base: 'relative h-[calc(100vh-7.5rem)] lg:h-[calc(100vh-8rem)] overflow-hidden w-full',
    nav: 'absolute top-4 left-0 w-full h-fit mx-auto z-[2] overflow-auto',
    navList: 'navList flex justify-center flex-nowrap [&>li]:shrink-0 w-max mx-auto px-2 md:px-2',
    figure: 'absolute top-0 left-0 size-full object-cover overflow-hidden z-0 scale-120 after:content-[\'\'] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-black/20',
    image: 'size-full object-cover',
    card: 'absolute bottom-2 left-2 right-2 md:right-4 md:bottom-4 md:left-4 md:w-[52rem] 2xl:max-w-[62rem] h-fit bg-white p-2 md:p-4 rounded-l z-[3]',
    contentList: 'overflow-hidden',
    contentContainer: 'h-full overflow-hidden',
    content: 'pt-1 md:pt-2 max-w-[70ch]'
  },
	variants: {
		hasArrows: {
			true: {
				nav: 'left-[4.6rem] w-[calc(100%-9.2rem)] md:w-full',
			},
			false: {
				nav: '',
			}
		},
	}
})

export type GalleryVariants = VariantProps<typeof styles>
